(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/web-comps/swiper.js
  var BSwiper = class extends HTMLElement {
    connectedCallback() {
      this.options = JSON.parse(this.getAttribute("data-options"));
      this.isDesktopOnly = this.hasAttribute("data-dt-only");
      this.waitForSwiper();
    }
    waitForSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(() => this.waitForSwiper(), 100);
        return;
      }
      this.initSwiper();
      window.addEventListener("resize", this.handleResize.bind(this));
    }
    initSwiper() {
      if (this.isDesktopOnly) {
        if (window.innerWidth >= 701) {
          if (!this.swiper) {
            this.swiper = new Swiper(this, this.options);
            this.swiper.init();
          }
        } else if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      } else {
        if (!this.swiper) {
          this.swiper = new Swiper(this, this.options);
          this.swiper.init();
        }
      }
    }
    handleResize() {
      this.initSwiper();
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize.bind(this));
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  };
  customElements.define("b-swiper", BSwiper);

  // scripts/web-comps/ticker-el.js
  var TickerEl = class extends HTMLElement {
    constructor() {
      super();
      __publicField(this, "init", () => {
        const content = this.initialContent;
        this.innerHTML = `
      <div class="b-ticker-wrapper">
        <div class="b-ticker-content">
          ${content}
        </div>
        <div class="b-ticker-content" aria-hidden="true">
          ${content}
        </div>
      </div>
    `;
      });
      __publicField(this, "reverse", () => {
        this.innerHTML = this.initialContent;
      });
      this.isMobile = window.innerWidth <= 700;
      this.animationTimeout = null;
    }
    connectedCallback() {
      this.initialContent = this.innerHTML;
      if (this.isMobile) {
        this.init();
        this.initializeAnimation();
      }
      window.addEventListener("resize", this.handleResize.bind(this));
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize.bind(this));
      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }
    }
    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 700;
      if (wasMobile !== this.isMobile) {
        const wrapper = this.querySelector(".b-ticker-wrapper");
        if (this.isMobile) {
          this.init();
          setTimeout(() => {
            this.initializeAnimation();
          }, 100);
        } else {
          this.reverse();
          wrapper.style.animation = "none";
          wrapper.style.width = "auto";
        }
      }
    }
    initializeAnimation() {
      const wrapper = this.querySelector(".b-ticker-wrapper");
      const images = wrapper.getElementsByTagName("img");
      let loadedImages = 0;
      const startAnimation = () => {
        const firstContent = wrapper.querySelector(".b-ticker-content");
        const contentWidth = firstContent.offsetWidth;
        wrapper.style.width = `${contentWidth * 2}px`;
        wrapper.style.animation = `ticker ${contentWidth / 50}s linear infinite`;
      };
      if (images.length === 0) {
        startAnimation();
        return;
      }
      Array.from(images).forEach((img) => {
        if (img.complete) {
          loadedImages++;
          if (loadedImages === images.length) {
            this.animationTimeout = setTimeout(startAnimation, 100);
          }
        } else {
          img.addEventListener("load", () => {
            loadedImages++;
            if (loadedImages === images.length) {
              this.animationTimeout = setTimeout(startAnimation, 100);
            }
          });
        }
      });
    }
  };
  customElements.define("ticker-el", TickerEl);

  // scripts/web-comps/accordion.js
  var Accordion = class extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.activeItem = null;
    }
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll("[data-acc-item]"));
      this.setupAccordion();
    }
    setupAccordion() {
      this.items.forEach((item) => {
        const trigger = item.querySelector("[data-acc-trigger]");
        const content = item.querySelector("[data-acc-content]");
        if (!trigger || !content) return;
        content.style.height = "0px";
        content.style.overflow = "hidden";
        content.style.transition = "height 0.3s ease-in-out";
        trigger.addEventListener("click", () => this.toggleItem(item));
        trigger.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.toggleItem(item);
          }
        });
      });
    }
    toggleItem(item) {
      const trigger = item.querySelector("[data-acc-trigger]");
      const content = item.querySelector("[data-acc-content]");
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      this.items.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherTrigger = otherItem.querySelector("[data-acc-trigger]");
          const otherContent = otherItem.querySelector("[data-acc-content]");
          otherTrigger.setAttribute("aria-expanded", "false");
          otherContent.setAttribute("aria-hidden", "true");
          otherContent.style.height = "0px";
        }
      });
      if (!isExpanded) {
        trigger.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");
        content.style.height = `${content.scrollHeight}px`;
      } else {
        trigger.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
        content.style.height = "0px";
      }
    }
  };
  customElements.define("b-acc-ordion", Accordion);

  // scripts/web-comps/tabs.js
  var BTabs = class extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector("b-tabs-list");
      this.tabButtons = this.querySelectorAll("[data-b-tabs-button]");
      this.tabItems = this.querySelectorAll("b-tabs-item");
      this.activeTab = null;
    }
    connectedCallback() {
      this.setupTabs();
      this.setupKeyboardNavigation();
    }
    setupTabs() {
      this.tabButtons.forEach((button, index) => {
        const tabId = button.getAttribute("data-tab-id");
        const tabItem = this.querySelector(`b-tabs-item[data-tab-id="${tabId}"]`);
        if (index === 0) {
          if (tabItem) {
            tabItem.classList.add("is-active");
          }
          button.classList.add("is-active");
          button.setAttribute("aria-selected", "true");
          button.setAttribute("tabindex", "0");
        } else {
          if (tabItem) {
            tabItem.setAttribute("hidden", "");
          }
          button.setAttribute("aria-selected", "false");
          button.setAttribute("tabindex", "-1");
        }
        button.addEventListener("click", () => this.switchTab(button));
      });
      this.activeTab = this.tabButtons[0];
    }
    setupKeyboardNavigation() {
      this.tabList.addEventListener("keydown", (e) => {
        const currentIndex = Array.from(this.tabButtons).indexOf(this.activeTab);
        switch (e.key) {
          case "ArrowLeft":
            e.preventDefault();
            this.switchTab(this.tabButtons[Math.max(0, currentIndex - 1)]);
            break;
          case "ArrowRight":
            e.preventDefault();
            this.switchTab(this.tabButtons[Math.min(this.tabButtons.length - 1, currentIndex + 1)]);
            break;
          case "Home":
            e.preventDefault();
            this.switchTab(this.tabButtons[0]);
            break;
          case "End":
            e.preventDefault();
            this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
            break;
        }
      });
    }
    switchTab(newTab) {
      if (this.activeTab === newTab) return;
      this.activeTab.setAttribute("aria-selected", "false");
      this.activeTab.setAttribute("tabindex", "-1");
      this.activeTab.classList.remove("is-active");
      newTab.setAttribute("aria-selected", "true");
      newTab.setAttribute("tabindex", "0");
      newTab.classList.add("is-active");
      newTab.focus();
      const oldTabId = this.activeTab.getAttribute("data-tab-id");
      const newTabId = newTab.getAttribute("data-tab-id");
      const oldPanel = this.querySelector(`b-tabs-item[data-tab-id="${oldTabId}"]`);
      const newPanel = this.querySelector(`b-tabs-item[data-tab-id="${newTabId}"]`);
      if (oldPanel) {
        oldPanel.setAttribute("hidden", "");
        oldPanel.classList.remove("is-active");
      }
      if (newPanel) {
        newPanel.removeAttribute("hidden");
        newPanel.classList.add("is-active");
      }
      this.activeTab = newTab;
    }
  };
  customElements.define("b-tabs", BTabs);

  // scripts/web-comps/recently-viewed-products.js
  var RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
      super();
      __publicField(this, "initializeRecentlyViewed", () => {
        let recentlyViewed = this.getRecentlyViewedFromStorage();
        if (this.currentProductData) {
          recentlyViewed = recentlyViewed.filter((product) => product.id !== this.currentProductData.id);
          recentlyViewed.unshift(this.currentProductData);
          recentlyViewed = recentlyViewed.slice(0, this.maxProducts + 3);
          localStorage.setItem("recently_viewed", JSON.stringify(recentlyViewed));
        }
        this.displayRecentlyViewed(recentlyViewed);
      });
      __publicField(this, "getRecentlyViewedFromStorage", () => {
        try {
          const storedItems = localStorage.getItem("recently_viewed");
          return storedItems ? JSON.parse(storedItems) : [];
        } catch (e) {
          console.error("Error retrieving recently viewed products:", e);
          return [];
        }
      });
      __publicField(this, "displayRecentlyViewed", async (products) => {
        if (this.currentProductData) {
          products = products.filter((product) => product.id !== this.currentProductData.id);
        }
        products = products.slice(0, this.maxProducts);
        if (products.length === 0) {
          this.emptyElement.style.display = "block";
          return;
        }
        this.emptyElement.style.display = "none";
        for (const product of products) {
          const productElement = document.createElement("div");
          productElement.className = "b-b-collection__item swiper-slide";
          try {
            const response = await fetch(`/products/${product.handle}?view=b-product-item`);
            if (!response.ok) throw new Error("Failed to fetch product snippet");
            const html = await response.text();
            productElement.innerHTML = html;
            this.gridElement.appendChild(productElement);
          } catch (error) {
            console.log("error", error);
            console.error("Error loading product snippet:", error);
          }
        }
      });
      this.maxProducts = this.dataset.limit || 4;
      this.gridElement = this;
      this.emptyElement = this.querySelector(".b-b-collection__empty");
      this.currentProductData = null;
      const currentProductElement = document.getElementById("current-product-data");
      if (currentProductElement) {
        try {
          this.currentProductData = JSON.parse(currentProductElement.textContent);
        } catch (e) {
          console.error("Error parsing current product data:", e);
        }
      }
    }
    connectedCallback() {
      this.initializeRecentlyViewed();
    }
  };
  customElements.define("recently-viewed-products", RecentlyViewedProducts);

  // scripts/8080.js
  console.log(8080);
  var localizationForm = document.querySelector("#currency-switcher form");
  if (localizationForm) {
    const selects = localizationForm.querySelectorAll("select");
    selects && selects.forEach((select) => {
      select.addEventListener("change", (e) => {
        localizationForm.submit();
      });
    });
  }
})();
